import { useReserveMask } from 'api/invite/hooks';
import { MaskSelection } from 'components/invitationScreen/maskSelection';
import { InvitationScreenLayout } from 'layout/inviteLayout';
import { InfoIcon } from 'lucide-react';
import toast from 'react-hot-toast';
import { useNavigate, useSearchParams } from 'react-router';

const InvitationScreen = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const { mutate: reserveMask, isPending } = useReserveMask({
		onSuccess: () => {
			toast.success('Congratulations! Your mask has been reserved');

			navigate({
				pathname: '/invitation/guest',
				search: `?${searchParams.toString()}`
			});
		},
		onError: (error) => {
			const defaultMessage = 'Something went wrong while reserving mask';
			const responseMessage = error?.response?.data?.message;

			if (responseMessage === 'Error: User has already selected a reward for this campaign in POST select campaign reward!') {
				navigate({
					pathname: '/invitation/guest',
					search: `?${searchParams.toString()}`
				});

				toast('You already have a reserved mask', {
					icon: <InfoIcon />
				});

				return;
			}

			const errorMessage = responseMessage && responseMessage.length <= 100
				? responseMessage
				: defaultMessage;

			toast.error(errorMessage);
		},
	});

	return (
		<InvitationScreenLayout>
			<MaskSelection
				reserveMask={reserveMask}
				disableReserveButton={isPending}
			/>
		</InvitationScreenLayout>
	);
};

export default InvitationScreen;
